import React from 'react';
import styled from 'styled-components';
import {useIntl} from 'react-intl';
import {TextArea} from '@forecast-it/design-system';
import {NovaAgentDraft} from '../state/useNovaAgentDraft';
import {PromptTarget} from '../state/useNovaPromptState';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	min-height: 0;
`;

// Tall enough to work with a multi-section agent.md without immediately needing to scroll.
const EDITOR_HEIGHT = 480;

interface Props {
	draft: NovaAgentDraft;
}

// The agent.md editor, bound to the shared working draft.
export function NovaAgentMdTab({draft}: Props): JSX.Element {
	const {formatMessage} = useIntl();
	const {values, setValue} = draft.promptState;

	return (
		<Container data-cy="nova-agent-md-tab" data-testid="nova-agent-md-tab">
			<TextArea
				label={formatMessage({id: 'nova.agentMd.label'})}
				data-cy="nova-agent-md"
				value={values.agentMd}
				onChange={(value: string) => setValue(PromptTarget.AgentMd, value)}
				onBlur={() => undefined}
				isOptional={false}
				height={EDITOR_HEIGHT}
				width={TextArea.WIDTH.FLEX}
			/>
		</Container>
	);
}
